import type { LanguageTokens } from 'i18n'
import familyTreeImage from 'images/family-invite/raizeira.webp'
import { Cdn } from 'utils/assets'

export { familyTreeImage }

export const FAMILY_TREE_SLUG = 'raizeira'

export const familyTreeSilhouetteImage = Cdn.getLottieAnimation(
  `forest/${FAMILY_TREE_SLUG}/silhueta.svg`
)

export const FAMILY_INVITE_LANDING_URL =
  'https://familia.arvore.com.br/app-v2/familia/boas-vindas?origem=convite-aluno'

export const FAMILY_INVITE_FLAG = 'alunoconvitefamilia'

export const FAMILY_NOTICE_FLAG = 'alunoavisofamilia'

export const FAMILY_STUDENT_STATUS_URL =
  '/api-arvore/family-signup/student/status'

export const FAMILY_TREE_SHEET_SEEN_KEY = 'arvore.family-tree-sheet-seen'

export type PhoneOwner = 'guardian' | 'student'

export const FAMILY_INVITE_TITLE: LanguageTokens = 'Chamar responsável'
